module.exports = "/assets/51d601082bea3c05b7d67ab010cecab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tube_icon.png
// module id = 714
// module chunks = 0